import "../.././styles/Constitution.css";

function Provisions() {
    return(
            <div className="container">
                <div className="sub-container constitution" >
                    <h3>GENERAL PROVISIONS</h3>
                    <p>
                        This Constitution &amp; By-Laws of the Philippine Canadian Centre of Manitoba, Inc. (PCCM),and any law
                        that is inconsistent with the provisions of the Constitution is, to the extent of the inconsistency, of no
                        force or effect.
                    </p>
                    <br /><br />
                    <p>
                        Any amendment to this Constitution &amp; By-Laws shall be made in accordance with the authority
                        contained in the Constitution &amp; By-Laws of PCCM. They shall be presented to the PCCM members and
                        shall be ratifiedby a majority vote of all members present at a General Membership Meeting of PCCM.
                    </p>
                    <br /><br />
                    <p>
                        Any amendment of this Constitution &amp; By-Laws shall be attached hereto and made a part hereof for all
                        purposes and any amendment shall be kept on record and be available to any member of PCCM.
                    </p>
                    <br /><br />
                    <p>
                        This Constitution shall take effect immediately upon its ratification by a majority of the votes cast
                        in an election held for the purpose and shall supersede all previous Constitution and By-Laws of PCCM.
                    </p>
                    <br /><br />
                    <p><b>
                        RATIFIED by majority of members present at the General Membership Meeting of PCCM in the City of
                        Winnipeg, Manitoba, Canada this 25th day of March, 2023.
                    </b></p>
                </div>
            </div>
    );
}

export default Provisions;